import type { TaskSummary } from '../../../api/types'
import { TableWrap } from '../../../components/ui/Table'
import { Badge } from '../../../components/ui/Badge'
import { PriorityBadge } from './PriorityBadge'
import { AssigneeStack } from './AssigneeStack'
import { EmptyState } from '../../../components/ui/EmptyState'

export function TaskListView({ tasks, onOpenTask }: { tasks: TaskSummary[]; onOpenTask: (id: string) => void }) {
  if (tasks.length === 0) {
    return <EmptyState mascot title="Keine Aufgaben" description="Für die aktuelle Filterung wurden keine Aufgaben gefunden." />
  }

  return (
    <TableWrap>
      <table>
        <thead>
          <tr>
            <th>Titel</th>
            <th>Status</th>
            <th>Priorität</th>
            <th>Verantwortliche</th>
            <th>Fällig</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map((task) => (
            <tr key={task.id} onClick={() => onOpenTask(task.id)} style={{ cursor: 'pointer' }}>
              <td>
                <div style={{ fontWeight: 600 }}>{task.title}</div>
                {task.labels.length > 0 ? (
                  <div style={{ display: 'flex', gap: 4, marginTop: 4 }}>
                    {task.labels.map((l) => (
                      <Badge key={l.labelId} style={{ background: `${l.label.color}22`, color: l.label.color }}>
                        {l.label.name}
                      </Badge>
                    ))}
                  </div>
                ) : null}
              </td>
              <td>
                <Badge variant={task.status.isDone ? 'success' : 'neutral'} dot>
                  {task.status.name}
                </Badge>
              </td>
              <td>
                <PriorityBadge priority={task.priority} />
              </td>
              <td>
                <AssigneeStack users={task.assignees.map((a) => a.user)} />
              </td>
              <td style={{ color: 'var(--text-secondary)' }}>
                {task.dueDate ? new Date(task.dueDate).toLocaleDateString('de-DE') : '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableWrap>
  )
}
